import React,{Component}from 'react'
import Textfield from '@atlaskit/textfield';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import {getSessionId, getToken,getUser}from '../util'
export default class CustomerCard extends Component{
    constructor(props){
        super(props)
        this.state={
          changePin:'',
          modalOpen:false,
          style : {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 1000,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            },
        }
    }
    onModelClick=()=>{
      this.setState({modalOpen:true})  
    }
    onPinChange=()=>{
      this.setState({modalOpen:false})  
    }
    componentDidMount=()=>{
      this.ongetCustomerDetails(getUser().emailid)
    }
  ongetCustomerDetails=(emailId)=>{
      fetch(`eadmin/v1/set/get_customer_licence_details?emailId=${emailId}` ,{
        method: 'GET',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken()
        },
        }).then((response) => response.json())
        .then((responseJson) => {
        if(responseJson.status && responseJson.result.length>0){
          this.setState({productData:responseJson.result})
        }else if(!responseJson.status){
            alert(responseJson.errorMsg)
        }else{
            alert('no record found')
        }
    }).catch((error) => {
        alert(error)
    });
    }
 
    render(){
        return(
          <>
            <Box  elevation={3}
            sx={{
              backgroundColor: 'white',
             
            }}>
          <center><p style={{paddingLeft:'15px',fontWeight:'600',color:'black'}}>Customer Details</p></center>
       
            <Grid container spacing={2}>
                <Grid item md={6}>
                <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>Company Name </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.props.companyname}</p></Grid>
                <Grid item xs={3} md={3} sm={3}>
               
                </Grid>
                {/*<Grid item xs={1} sm={1} md={1}/>

                <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>Address </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.props.address}</p></Grid>
                <Grid item xs={3} md={3} sm={3}>
               
              </Grid>

                <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>City </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={5} sm={5} md={5}><p style={{fontWeight:'600',fontSize:15}}>{this.props.city} </p></Grid>
                <Grid item xs={2} md={2} sm={3}>
       
              </Grid>
                <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>StateName </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={5} sm={5} md={5}><p style={{fontWeight:'600',fontSize:15}}>{this.props.state}</p></Grid>
                <Grid item xs={2} md={2} sm={2}/>
                    
        
                <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p> Pincode </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={5} sm={5} md={5}><p>{this.props.pincode}</p><br/></Grid>
               <Grid item xs={2} md={2} sm={2}/> */}

               <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p> EmailID </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={5} sm={5} md={5}><p>{this.props.email}</p><br/></Grid>
               <Grid item xs={2} md={2} sm={2}/> 

               <Grid item xs={1} sm={1} md={1}/>
                <Grid item xs={3} sm={3} md={3}><p> MobileNo </p></Grid>
                <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                <Grid item xs={5} sm={5} md={5}><p>{this.props.mobileno}</p><br/></Grid>
               <Grid item xs={2} md={2} sm={2}/> 
               </Grid>
               </Grid>
               <Grid item md={6}>
               <Grid container spacing={2}>
               <Grid item md={2}/>
                <Grid item md={8}>
                <FormControl sx={{ m:1, width: '75%' }}>
                <label style={{paddingBottom:'10px'}}>Support Pin <a href="#" style={{textDecoration:'none',color:'blue',paddingLeft:'40%'}} onClick={this.props.onClick}>Change</a></label>
                <Textfield  aria-label="default text field"   value={this.props.supportpin} />
                </FormControl>
              </Grid>
              <Grid item md={2}/>
              <Grid item md={2}/>
              <Grid item md={8}>
              <FormControl sx={{ m:1, width: '75%' }}>
                <label style={{paddingBottom:'10px'}}>Num of System</label>
                <Textfield  aria-label="default text field"  value={this.props.noofsystem} />
             </FormControl>
              </Grid>
              <Grid item md={2}/>
              <Grid item md={2}/>
              <Grid item md={8}>
                <FormControl sx={{ m:1, width: '75%' }}>
                <label style={{paddingBottom:'10px'}}>Num of Mobile User</label>
                <Textfield  aria-label="default text field"  value={this.props.noofmobileuser}/>
              </FormControl>
              </Grid>
              <Grid item md={2}/>
            </Grid>
            </Grid>
            </Grid>
            <center><Button variant="contained" onClick={this.props.onDisconnect}>SURRENDER</Button></center>
          </Box>   
        
                      </>
        )
    }
        
}